module.exports = __webpack_public_path__ + "img/pluto111.ff11d3d0.jpg";